import {recordRumDurationVital} from '../datadogRum';

export const IMMER_PERFORMANCE_MIN_DURATION_MS = 2;

const normalizeActionType = (actionType: string): string =>
  actionType
    .replace(/^@+/, '')
    .replace(/[^a-zA-Z0-9]+/g, '.')
    .replace(/^\.|\.$/g, '');

/**
 * Starts a synchronous views Immer measurement and returns an idempotent
 * callback that reports actions exceeding the configured duration threshold.
 */
export function startImmerPerformanceMeasure(actionType: string): () => void {
  const startMark = performance.now();
  let finished = false;

  return () => {
    if (finished) {
      return;
    }
    finished = true;

    const duration = performance.now() - startMark;
    if (duration <= IMMER_PERFORMANCE_MIN_DURATION_MS) {
      return;
    }

    recordRumDurationVital(
      `workspace.immer.${normalizeActionType(actionType)}`,
      {
        startTime: performance.timeOrigin + startMark,
        duration,
        description: `synchronous views Immer duration for ${actionType}`,
        context: {
          actionType,
          reducer: 'views',
        },
      }
    );
  };
}
